// extracted by mini-css-extract-plugin
export var deleteModal = "_h8-0";